module.exports = __webpack_public_path__ + "img/andes_logo.15816c30.jpg";